import React from 'react'
import Svg from './Svg'
export const SvgBell = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M24 19.5a4.5 4.5 0 01-4.5-4.5V8.318c0-3.298-2.577-6.05-6-6.681V0h-3v1.636c-3.423.632-6 3.384-6 6.682V15A4.5 4.5 0 010 19.5V21h10.069a2.12 2.12 0 103.862 0H24v-1.5z" />
  </Svg>
))
SvgBell.isIcon = true
export default SvgBell
